<template>
  <div id="app">
    <a-page-header
      v-if="
        $route.name !== 'Login' &&
        $route.name !== 'LoginEucerin' &&
        $route.name !== 'LoginEucerinTest' &&
        $route.name !== 'Register' &&
        $route.name !== 'Home' &&
        $route.name !== 'AdminLogin' &&
        $route.name !== 'AdminMessageScreen' &&
        $route.name !== 'LiveSessions'
      "
      style="border: 1px solid rgb(235, 237, 240)"
      @back="goBack"
    >
      <span slot="backIcon">
        <a-icon v-if="$route.name !== 'Sessions'" slot="backIcon" type="left" />
      </span>
      <div
        v-if="
          $route.name !== 'AdminDashboard' &&
          $route.name !== 'AdminSession' &&
          $route.name !== 'AdminUsersLog' &&
          $route.name !== 'AdminUser'
        "
        id="logo-wrapper"
        slot="subTitle"
      >
        <a-icon
          v-if="!$store.state.headerLogo"
          class="logo-loading"
          type="loading"
        />
        <img v-else id="logo" :src="$store.state.headerLogo" />
      </div>
      <div v-else id="logo-wrapper" slot="subTitle">
        <img id="logo" :src="livetubeLogo" />
      </div>
      <div class="extra">
        <!-- <div
          v-if="this.$route.params.projectSlug == 'electrolux-demo'"
          class="desktop-menu"
        >
          <ul>
            <li><a href="#">LIVESTREAM</a></li>
            <li><a href="#">WORKSHOPS</a></li>
            <li><a href="#">VIRTUAL SHOWROOMS</a></li>
            <li><a href="#">CONTENT ON DEMAND</a></li>
            <li><a href="#">SUPPORT</a></li>
          </ul>
        </div> -->
        <a-dropdown placement="bottomCenter">
          <a-button shape="circle" icon="user" />
          <a-menu slot="overlay">
            <a-menu-item v-if="user">
              <span>{{ user.name }}</span>
            </a-menu-item>
            <a-menu-item>
              <span @click="logout()">Logout</span>
            </a-menu-item>
          </a-menu>
        </a-dropdown>
      </div>
    </a-page-header>
    <router-view />
  </div>
</template>

<script>
export default {
  name: 'App',
  data() {
    return {
      livetubeLogo: require('@/assets/logo-livetubex.svg'),
      setLoginInterval: null,
      duplicateLoginCount: 0,
      user: null,
      loginStatus: {},
    }
  },
  async mounted() {
    if (!localStorage.uuid) {
      localStorage.uuid = this.uuidv4()
    }
    this.setLoginInterval = setInterval(async () => {
      if (this.$route.params.projectSlug) {
        if (
          localStorage[
            `auth:live-tube-portal:${this.$route.params.projectSlug}`
          ]
        ) {
          const userData = JSON.parse(
            localStorage[
              `auth:live-tube-portal:${this.$route.params.projectSlug}`
            ]
          )
          this.user = userData
          const messageRef = this.$rdb.ref(
            `user-login-status/${this.$route.params.projectSlug}/${userData.username}`
          )
          messageRef.once('value', (snapshot) => {
            if (snapshot.val()) {
              const loginStatus = snapshot.val()
              if (loginStatus.uuid !== localStorage.uuid) {
                // this.$store.commit('notiNewDeviceLogin', true)
                localStorage.removeItem(
                  `auth:live-tube-portal:${this.$route.params.projectSlug}`
                )
                this.$router.push({
                  name: 'Login',
                  params: {
                    projectSlug: this.$route.params.projectSlug,
                  },
                })
              }
            }
          })
        }
      }
    }, 5000)
  },
  methods: {
    logout() {
      const userData = JSON.parse(
        localStorage.getItem(
          `auth:live-tube-portal:${this.$route.params.projectSlug}`
        )
      )
      if (userData) {
        localStorage.removeItem(
          `auth:live-tube-portal:${this.$route.params.projectSlug}`
        )
        this.$router.push({
          name: 'Login',
          params: {
            projectSlug: this.$route.params.projectSlug,
          },
        })
      } else {
        const currentUser = this.$auth.currentUser
        this.$auth.signOut()
        if (currentUser) {
          this.$router.push({ name: 'AdminLogin' })
        }
      }
      // const userData = JSON.parse(
      //   localStorage.getItem(
      //     `auth:live-tube-portal:${this.$route.params.projectSlug}`
      //   )
      // )
      // if (userData) {
      //   this.updateLoginStatus(userData)
      // }
      // this.$auth.signOut()
      // localStorage.removeItem(
      //   `auth:live-tube-portal:${this.$route.params.projectSlug}`
      // )
      // localStorage.removeItem('last_session')
      // setTimeout(() => {
      //   this.$router.go()
      // }, 1000)
    },
    updateLoginStatus(userData) {
      this.$db.collection('login-status').doc(userData.uid).delete()
    },
    goBack() {
      this.$router.go(-1)
    },
    uuidv4() {
      return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(
        /[xy]/g,
        function (c) {
          const r = (Math.random() * 16) | 0
          const v = c === 'x' ? r : (r & 0x3) | 0x8
          return v.toString(16)
        }
      )
    },
  },
}
</script>
<style lang="scss">
@font-face {
  font-family: 'anuphan';
  src: url('assets/fonts/anuphan-light.woff2') format('woff2'),
    url('assets/fonts/anuphan-light.woff') format('woff');
  font-weight: 200;
  font-style: normal;
}

@font-face {
  font-family: 'anuphan';
  src: url('assets/fonts/anuphan-medium.woff2') format('woff2'),
    url('assets/fonts/anuphan-medium.woff') format('woff');
  font-weight: 300;
  font-style: normal;
}

@font-face {
  font-family: 'anuphan';
  src: url('assets/fonts/anuphan-regular.woff2') format('woff2'),
    url('assets/fonts/anuphan-regular.woff') format('woff');
  font-weight: 400;
  font-style: normal;
}

@font-face {
  font-family: 'anuphan';
  src: url('assets/fonts/anuphan-semibold.woff2') format('woff2'),
    url('assets/fonts/anuphan-semibold.woff') format('woff');
  font-weight: 600;
  font-style: normal;
}

@font-face {
  font-family: 'gotham';
  src: url('assets/fonts/gotham-medium.woff2') format('woff2'),
    url('assets/fonts/gotham-medium.woff') format('woff');
  font-weight: 400;
  font-style: normal;
}

@font-face {
  font-family: 'gotham';
  src: url('assets/fonts/gotham-bold.woff2') format('woff2'),
    url('assets/fonts/gotham-bold.woff') format('woff');
  font-weight: 700;
  font-style: normal;
}

@font-face {
  font-family: 'db_airycaps_bd';
  src: url('assets/fonts/db_airy_caps_bd_v3.2.woff2') format('woff2'),
    url('assets/fonts/db_airy_caps_bd_v3.2.woff') format('woff');
  font-weight: normal;
  font-style: normal;
}

@font-face {
  font-family: 'db_airystd_bd';
  src: url('assets/fonts/db_airy_std_bd_v3.2.woff2') format('woff2'),
    url('assets/fonts/db_airy_std_bd_v3.2.woff') format('woff');
  font-weight: normal;
  font-style: normal;
}

@font-face {
  font-family: 'db_airystd_med';
  src: url('assets/fonts/db_airy_std_med_v3.2.woff2') format('woff2'),
    url('assets/fonts/db_airy_std_med_v3.2.woff') format('woff');
  font-weight: normal;
  font-style: normal;
}

@font-face {
  font-family: 'db_airystd';
  src: url('assets/fonts/db_airy_std_v3.2.woff2') format('woff2'),
    url('assets/fonts/db_airy_std_v3.2.woff') format('woff');
  font-weight: normal;
  font-style: normal;
}

// audio,
// canvas,
// embed,
// iframe,
// object,
// svg,
// video {
img {
  margin: 0 auto;
}

.logo-loading {
  font-size: 1.3em;
  padding-left: 15px;
}

#logo-wrapper {
  text-align: center;
}
#logo {
  height: 20px;
}

.ant-page-header.ant-page-header-ghost {
  display: grid;
  grid-template-columns: 1fr 2fr;
  padding-top: 18px;
  padding-bottom: 18px;
  max-height: 70px;
  background-color: #fff;
}

@media (max-width: 768px) {
  .ant-page-header.ant-page-header-ghost {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    z-index: 100;
  }
}

@media (max-width: 576px) {
  .ant-page-header.ant-page-header-ghost {
    grid-template-columns: 2fr 1fr;
    padding: 8px;
    max-height: 50px;
  }
}

.ant-page-header.ant-page-header-ghost > div {
  padding-top: 0 !important;
}

.extra {
  float: right;
}
.desktop-menu {
  display: inline-block;
  margin-right: 30px;
  vertical-align: top;
  ul {
    vertical-align: top;
    margin: 0;
    list-style: none;
    li {
      display: inline-block;
      padding-left: 10px;
      padding-right: 10px;
      a {
        display: block;
        font-weight: 700;
        line-height: 50px;
        color: #fff;
      }
    }
  }
}
@media (max-width: 576px) {
  .desktop-menu {
    display: none;
  }
}
</style>
